import { render } from "./Button.vue?vue&type=template&id=1eeb23e2"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=1eeb23e2&lang=less"
/* custom blocks */
import block0 from "./Button.vue?vue&type=custom&index=0&blockType=comment"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__